export interface TreeRelationshipRecord {
  readonly id: string;
  readonly relationship: string;
  readonly category: string;
}

const TREE_RELATIONSHIP_REGISTRY: readonly TreeRelationshipRecord[] =
Object.freeze([
  { id: 'parent',        relationship: 'Parent',         category: 'direct' },
  { id: 'child',         relationship: 'Child',          category: 'direct' },
  { id: 'co-parent',     relationship: 'Co-Parent',      category: 'modern-family' },
  { id: 'spouse',        relationship: 'Spouse',         category: 'marriage' },
  { id: 'sibling',       relationship: 'Sibling',        category: 'direct' },
  { id: 'grandparent',   relationship: 'Grandparent',    category: 'extended' },
  { id: 'grandchild',    relationship: 'Grandchild',     category: 'extended' },
  { id: 'step-parent',   relationship: 'Step Parent',    category: 'modern-family' },
  { id: 'step-child',    relationship: 'Step Child',     category: 'modern-family' },
  { id: 'chosen-family', relationship: 'Chosen Family',  category: 'chosen' },
  { id: 'in-law',        relationship: 'In-Law',         category: 'extended' },
]);

export function getTreeRelationshipRegistry():
readonly TreeRelationshipRecord[] {
  return TREE_RELATIONSHIP_REGISTRY;
}
